import { CalendarHolidaysRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: CalendarHolidaysRepository): Interactor {
  return (holiday) =>
    present(
      repository
        .removeHoliday(holiday)
        .then(() => holiday)
        .catch((e) => Promise.reject({ ...e, message: e.detail, holiday })),
    );
}

export type { Interactor };

export { createInteractor };
